import React from 'react';
import HeaderOffsetContainer from './HeaderOffsetContainer';

var HeaderOffset = function HeaderOffset(_ref) {
  var isFullHeight = _ref.isFullHeight,
      isBlurred = _ref.isBlurred,
      bgStart = _ref.bgStart,
      bgEnd = _ref.bgEnd,
      children = _ref.children;
  return /*#__PURE__*/React.createElement(HeaderOffsetContainer, {
    bgStart: bgStart,
    bgEnd: bgEnd,
    isFullHeight: isFullHeight,
    isBlurred: isBlurred
  }, children);
};

HeaderOffset.defaultProps = {
  bgStart: undefined,
  bgEnd: undefined,
  isFullHeight: false,
  isBlurred: false,
  children: undefined
};
export default HeaderOffset;